import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LabComponent } from './lab.component';
import { BoundingBoxVisualizerComponent } from './bounding-box-visualizer/bounding-box-visualizer.component';
import { LabService } from './lab.service';
import { MaterialModule } from '../material.module';
import { LabUnprocessedComponent } from './unprocessed/unprocessed.component';
import { labRoutes } from './lab.routes';
import { LabProcessedComponent } from './processed/processed.component';
import { LabLibraryComponent } from './library/library.component';
import { AuthenticationModule } from '../authentication/authentication.module';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule.forChild(labRoutes),
    AuthenticationModule,
  ],
  declarations: [
    LabComponent,
    BoundingBoxVisualizerComponent,
    LabUnprocessedComponent,
    LabProcessedComponent,
    LabLibraryComponent,
  ],
  providers: [LabService],
})
export class LabModule {}
